<ng-container *ngIf="partnerLogos$ | async as partnerLogos">
  <ng-container *ngFor="let partnerLogo of partnerLogos">
    <cx-generic-link [title]="partnerLogo.altText">
      <cx-media [container]="partnerLogo.media" [alt]="partnerLogo.altText"></cx-media>
    </cx-generic-link>
  </ng-container>
</ng-container>
